import { jsx as _jsx } from "react/jsx-runtime";
import { useActions, useGlobalState } from "piral-core";
import { toast } from "react-toastify";
import { ToastPending, ToastSuccess, ToastError } from "../toastify/ToastView";
export function createCustomApi() {
    return context => {
        const _useGlobalComponents = (name) => {
            let nameFn = useGlobalState((m) => m.components[name]);
            return nameFn;
        };
        const _useGlobalState = (name) => {
            let nameFn = useGlobalState((m) => m[name]);
            return nameFn;
        };
        const _useActions = () => {
            let nameFn = useActions();
            return nameFn;
        };
        const _toastCreate = ({ customId, info }) => {
            return toast(_jsx(ToastPending, { info: info }), {
                toastId: customId,
                isLoading: true,
                closeButton: false
            });
        };
        const _toastUpdate = ({ customId, type, info, hashLink, error }) => {
            const domView = type === "success" ?
                _jsx(ToastSuccess, { info: info, hashLink: hashLink })
                : _jsx(ToastError, { info: info, error: error });
            return toast.update(customId, {
                render: domView,
                isLoading: false,
                closeButton: true,
                type: type,
                autoClose: 8000
            });
        };
        const _toastPromise = ({ event, info, hashLink, error }) => {
            return toast.promise(event, {
                pending: _jsx(ToastPending, { info: info }),
                success: _jsx(ToastSuccess, { info: info, hashLink: hashLink }),
                error: _jsx(ToastError, { info: info, error: error })
            });
        };
        const _toastView = ({ info, type }) => {
            return toast(info, {
                type: type
            });
        };
        return (api, meta) => ({
            _useGlobalComponents,
            _useGlobalState,
            _useActions,
            _toastView,
            _toastCreate,
            _toastUpdate,
            _toastPromise
        });
    };
}
